module.exports = require("@swa-ui/shopping/src/forms/FlightBookingForm/FlightBookingForm.module.scss");